import Close16 from '@carbon/icons-react/es/close/16';
// eslint-disable-next-line no-restricted-imports
import { Drawer as AntdDrawer, Tooltip } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

interface CloseIconProps {
  showTooltip: boolean;
}

const CloseIcon: FC<CloseIconProps> = ({ showTooltip }) => (
  <Tooltip
    placement="left"
    title={showTooltip && <FormattedMessage id="esc_to_close" />}
  >
    <Close16 />
  </Tooltip>
);

export const Drawer = styled(AntdDrawer).attrs<DrawerProps>((props) => {
  const { keyboard = true } = props;

  return {
    closeIcon: <CloseIcon showTooltip={keyboard} data-cy="antd-drawer.close" />,
    mask: false,
    ...props,
  };
})`
  .ant-drawer-close {
    display: flex;
    padding: var(--spacing-05);
    & > span {
      display: flex;
      align-items: center;
    }
    &:hover {
      background-color: var(--black-with-opacity);
    }
  }

  .ant-drawer-content-wrapper {
    &:before {
      background-color: transparent;
      content: '';
      bottom: 0;
      left: -100vw;
      pointer-events: none;
      position: fixed;
      top: 0;
      transition: background-color ease-in-out var(--animation-duration-medium);
      width: 100vw;
    }

    &:hover:before {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  .ant-drawer-footer {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding: var(--layout-02);

    > button + button {
      margin-left: var(--layout-01);
    }
  }
`;
